const Voucher_Use_Type = {
  MERCHANT: 1,
  REFERRAL: 2
};

export { Voucher_Use_Type };
